import React, { useState } from "react";

// Favicon component with fallback
const FaviconImage = ({ src, alt, className = "" }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  // Don't render anything if no src provided
  if (!src || hasError) {
    return null;
  }

  return (
    <div className={`relative ${className}`}>
      <img src={src} alt={alt} className="w-full h-full object-contain" onError={handleError} onLoad={handleLoad} style={{ display: isLoading ? "none" : "block" }} />
      {isLoading && <div className="absolute inset-0 bg-gray-800/50 rounded animate-pulse"></div>}
    </div>
  );
};

export default FaviconImage;
